import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

// Fetch hook with no loading or error state
const useFetchStrapiData = () => {
  const [data, setData] = useState([]);

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;

  useEffect(() => {
    const fetchData = async () => {
      if (!STRAPI_URL || !STRAPI_TOKEN) return;

      const path = "/api/home?populate=*";
      const url = new URL(STRAPI_URL + path);

      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        const result = await response.json();
        setData(result.data);
      } catch (err) {
        console.error("❌ Fetch error:", err.message);
      }
    };

    fetchData();
  }, [STRAPI_URL, STRAPI_TOKEN]);

  return { data };
};

const PageTitle = () => {
  const { data } = useFetchStrapiData();
  const { t } = useTranslation();

  return (
	  
	 <div className="container mt-5 mt-xl-10">
      <div className="row g-3 g-xl-5 align-items-end">
        <div className="col-lg-12">
          <h1 style={{ lineHeight: '80%' }}>
			<span className="display-2 text-black" style={{ fontWeight: 'bold', lineHeight: '50%' }}>{t("photos.title", "Photos")}</ span>
	  		<span className="display-4 text-black" style={{ lineHeight: '50%' }}><br />{t("photos.subtitle", "A personal take on the world—through quiet frames, fleeting light, and honest moments.")}</ span>
	  	  </h1>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
